import { setSafe } from "../../util/storeHelper";
import * as actions from "./actions";
const reducer = {
    reducers: {
        [actions.setPrimaryTool]: (state, payload) => setSafe(state, ["primaryTool", payload.gameId], payload.toolId),
        [actions.setToolOrder]: (state, payload) => {
            const { gameId, tools } = payload;
            return setSafe(state, ["tools", "order", gameId], tools);
        },
        [actions.setToolValid]: (state, payload) => {
            const { gameId, toolId, valid } = payload;
            return setSafe(state, ["tools", "valid", gameId, toolId], valid);
        },
        [actions.setToolPinned]: (state, payload) => {
            const { gameId, toolId, pinned } = payload;
            return setSafe(state, ["tools", "pinned", gameId, toolId], pinned);
        },
    },
    defaults: {},
};
export default reducer;
